import request from '@/utils/request'
const apiPath = '/cust/customerArea'
import { downloadBlob } from '@/utils/download'
const clientAreaApi = {
  /**
   * 新增【管辖区域】
   */
  create(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 新增 · 批量【管辖区域】
   *
   */
  saveBatch(data) {
    return request.post(apiPath + '/tee/saveBatch', data)
  },
  /**
   * 修改【管辖区域】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 分页查询【管辖区域】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee/list', { params: query })
  },
  fetchTreeList(query) {
    return request.get(apiPath + '/tee/treeListV3', { params: query })
  },
  /**
   * 查询【管辖区域】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【管辖区域】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 转让【管辖区域】
   */
  makeTransfer(data) {
    return request.post(`${apiPath}/tee/transfer`,data)
  },
  /**
   * 删除单个【管辖区域】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '商品列表.xlsx'))
  },
}
export default clientAreaApi
